import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import * as R from "ramda";
import Translator from "Languages/Utility/Translator";
import { editSpacer, GetAllSpacer } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import { DialogActions } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from 'react-i18next';
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MaxTowNumber from "Components/Input/components/MaxTowNumber";
import * as Icons from "react-bootstrap-icons";

export default function  EditSpacer({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { spacersPagination } = useSelector((state) => ({
    spacersPagination: state.shishe.spacersPagination,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({ nameshishe: true });
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [change, setChange] = useState(false);
  const [controls, setControls] = useSetState({
    spacerName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    thick: {
      type: "millimeter",
      value: 4,
      validation: {
        required: true,
        isNumeric: true,
        min: 4,
        minLength: 1,
        maxLength: 3,
      },
    },
    price: {
      type: "price",
      value: "",
      validation: {
        required: true,
        isPrice: true,
        notZero: true
      },
    },
  });

  const onEnter = async () => {
    setControls({ spacerName: { value: row.Name } });
    setControls({ thick: { value: row.Thick } });
    setControls({ price: { value: row.Price } });
  };

  const handleDialog = () => setOpenDialog(!openDialog);

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    setChange(true);
  }

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if(change) {
      if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
      ) {
        const { spacerName, thick, price } = controls;
        try {
          const data = {
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            Id: +row.Id,
            Price: +price.value,
            Name: spacerName.value,
            Thick: +thick.value,
          };
          await dispatch(editSpacer(data));
          await dispatch(GetAllSpacer({
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            Limit: 5,
            Page: spacersPagination.Page,
          }));
        } catch (err) {
          console.error('[CATCH]', err);
        }
      }
    } else {
      handleDialog();
    }
    setLoading(false);
  }

  const onExit = () => {
    setOpenDialog(false);
  }

  return (
    <>
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={
            !((row.IsG && read("StypeU") === "1") ||
              (!row.IsG && read("StypeU") !== "1" && read("ShisheRules").accessUpdate) || row.disabled)
        }
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{
          onEnter: onEnter,
          onExit: onExit
        }}
        onClose={handleDialog}
        fullWidth
        maxWidth="xs"
      >
        <BackDropLoading loading={loading} />
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"spacerEdit"} />}</p>
          </div>
          <DialogContent>
            <Grid container spacing={2}>
              {Object.keys(controls).map((key) => {
                  return (
                    <Grid item xs={12} key={key}>
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type={controls[key].type}
                        value={controls[key].value}
                        placeholder={t(key)}
                        endIcon={
                          controls[key].type === "price" ? (
                            <Translator id="moneyUnit" />
                          ) : controls[key].type === "millimeter" ? (
                            <Translator id="millimeter" />
                          ) : (
                            ""
                          )
                        }
                        inputComponent={
                          controls[key].type === "millimeter" && MaxTowNumber
                        }
                        minLength={controls[key]?.validation?.minLength}
                        maxlength={controls[key]?.validation?.maxLength}
                      />
                    </Grid>
                  );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
              disabled={loading}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
              disabled={loading}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
